import { type BaseStocktakeScannedRepository } from "../../_Bases/BaseStocktakeScannedRepository";
import { type LocalDatabaseStocktakeScanned } from "../../_Bases/BaseStocktakeScannedRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBStocktakeScannedRepository extends BaseIndexedDBRepository<
    LocalDatabaseStocktakeScanned,
    number
> implements BaseStocktakeScannedRepository {
    public readonly source: InternalIndexedDBDatabase["stocktakeScanned"];
    protected readonly dataTypeName = "Stocktake Scanned";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.stocktakeScanned;
    }

    public getByStocktake(stocktake: string): Promise<Array<LocalDatabaseStocktakeScanned>> {
        return this.source.where("stocktake_id").equals(stocktake).toArray();
    }
}
